import { Disclosure, Transition } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/20/solid";
import { Fragment } from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Faq(props) {
  const { question, answer } = props;
  return (
    <Disclosure>
      {({ open }) => (
        <>
          <Disclosure.Button className="w-full font-semibold text-start relative pr-7 ">
            {question}
            <ChevronRightIcon
              className={classNames(open ? "rotate-90 transform" : "", "h-5 w-5 absolute right-0 top-2/4 -translate-y-2/4 duration-300")}
            />
          </Disclosure.Button>
          <Transition as={Fragment} enter="transition ease-in duration-200" enterFrom="opacity-0" enterTo="opacity-100">
            <Disclosure.Panel className="mt-6 text-gray-500">{answer}</Disclosure.Panel>
          </Transition>
        </>
      )}
    </Disclosure>
  );
}
